export const searchWeightScorePattern = /^[+-]?\d{1,8}$/;
